<template>
    <modal-component v-model="modelValue">
        <div class="w-97 mt-2">
            <!-- Title -->
            <div class="text-lg font-medium text-secondary mb-8">
                Edit Permissions
            </div>

            <!-- Permission List -->
            <div class="flex mb-8">
                <div
                    v-for="permission in permissions"
                    :key="permission.id"
                    :title="getTooltip(permission)"
                    :class="getWrapperClasses(permission)"
                    @click="toggleCheckbox(permission)"
                >
                    <checkbox-component
                        :name="permission.name"
                        :checked="isSelected(permission)"
                        :disabled="isRolePermission(permission)"
                    />
                    {{ parsePermission(permission.name) }}
                </div>
            </div>

            <!-- Button -->
            <div class="flex justify-end">
                <button
                    class="
                        font-medium
                        text-white
                        border-2 border-primary
                        text-center text-sm
                        py-2
                        px-3.5
                        cursor-pointer
                        rounded-full
                        bg-primary
                        hover:bg-secondary
                        hover:text-white
                        hover:border-secondary
                        focus:outline-none
                        transition-colors
                        duration-500
                    "
                    @click="confirm"
                >
                    Confirm
                </button>
            </div>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "@/Components/Modal";
import CheckboxComponent from "@/Components/Checkbox";

export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        permissions: {
            type: Array,
            required: true,
        },
        user: {
            type: Object,
            default: null,
        },
    },
    components: {
        ModalComponent,
        CheckboxComponent,
    },
    data() {
        return {
            selectedPermissions: [],
        };
    },
    watch: {
        user(newValue) {
            // initialize list of selected permissions
            this.selectedPermissions = [];
            if (newValue && newValue.permissionList) {
                for (let permission of newValue.permissionList) {
                    this.selectedPermissions.push(permission);
                }
            }
        },
    },
    computed: {
        role() {
            let result = null;
            if (this.user && this.user.roles.length > 0) {
                // user should have only one role
                result = this.user.roles[0];
            }
            return result;
        },
        rolePermissions() {
            // permissions that are assigned to the user's role
            // not directly assigned to the user
            let result = [];
            if (this.role) {
                for (let permission of this.role.permissions) {
                    result.push(permission.name);
                }
            }
            return result;
        },
    },
    methods: {
        capitalizeFirstLetter(val) {
            return val.charAt(0).toUpperCase() + val.slice(1);
        },
        parsePermission(permission) {
            return this.capitalizeFirstLetter(permission.replace("-", " "));
        },
        isSelected(permission) {
            return this.selectedPermissions.includes(permission.name);
        },
        isRolePermission(permission) {
            return this.rolePermissions.includes(permission.name);
        },
        getTooltip(permission) {
            let result = null;
            if (this.isRolePermission(permission)) {
                result = "Assigned role requires this permission.";
            }
            return result;
        },
        getWrapperClasses(permission) {
            let result = ["mr-4", "flex", "items-center"];
            if (this.isRolePermission(permission)) {
                result.push("cursor-not-allowed");
                result.push("text-gray-400");
            } else {
                result.push("cursor-pointer");
            }
            return result;
        },
        toggleCheckbox(permission) {
            const index = this.selectedPermissions.indexOf(permission.name);
            if (index > -1 && !this.isRolePermission(permission)) {
                // remove permission
                this.selectedPermissions.splice(index, 1);
            } else {
                // add permission
                this.selectedPermissions.push(permission.name);
            }
        },
        confirm() {
            this.$emit("confirm", this.selectedPermissions);
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>
